import { RouteObject } from 'react-router-dom';
import { GRID } from './modules/GRID';
import { ORD } from './modules/ORD';
import { cardPath, deskPath, desksPath } from '../../GRID/addresses';
import { ORDPath } from '../../ORD/addresses';

export const routing: RouteObject[] = [
  { path: '/*', element: <GRID /> },
  { path: `${desksPath}/*`, element: <GRID /> },
  { path: `${deskPath}/*`, element: <GRID /> },
  { path: `${cardPath}/*`, element: <GRID /> },
  { path: 'Organizations/*', element: <ORD /> },
  { path: 'Organization/*', element: <ORD /> },
  { path: 'Contracts/*', element: <ORD /> },
  { path: 'Contract/*', element: <ORD /> },
  { path: `${ORDPath}/*`, element: <ORD /> },
];
